
import { defineComponent } from 'vue'

import Header from '@/components/Home/Header.vue'
import ValueProps from '@/components/Home/ValueProps.vue'
import MealManagement from '@/components/Home/MealManagement.vue'
import MealInput from '@/components/Home/MealInput.vue'
import Demo1 from '@/components/Home/Demo1.vue'
import Demo2 from '@/components/Home/Demo2.vue'
import Demo3 from '@/components/Home/Demo3.vue'
import Demo4 from '@/components/Home/Demo4.vue'
import Demo5 from '@/components/Home/Demo5.vue'
import DownloadCta from '@/components/Home/DownloadCta.vue'

import setMeta from '@/scripts/root/setMeta'

export default defineComponent({
  components: {
    Header,
    ValueProps,
    MealManagement,
    MealInput,
    Demo1,
    Demo2,
    Demo3,
    Demo4,
    Demo5,
    DownloadCta,
  },
  computed: {
    isMainRoute(): boolean {
      // 현재 URL 경로에 'PrivacyPolicy' 또는 'termsOfUse'가 포함되어 있지 않으면 true 반환
      return !(
        this.$route.path.includes('privacy-policy') ||
        this.$route.path.includes('terms-of-use')
      )
    },
  },
  created() {
    // 앱의 전체 타이틀(탭바 타이틀)
    // 탭바의 이미지를 변경하고 싶은 경우, favicon을 수정.
    setMeta(document)
  },
})
